module.exports = new __parcel__URL__("Retro.0a7a990a.svg").toString();